import React, { useEffect, useState } from 'react';
import logoSmall from '../assets/images/logo-small.svg';
import homeMobile from '../assets/images/home-mobile.png';
import home from '../assets/images/home.jpg';
import './VendorOffer.css';

export type VendorBranding = {
  vendorName: string | null;
  logoUrl: string | null;
  headline: string | null;
  bodyText: string | null;
  successText: string | null;
  questionnaireSlug: string | null;
};

export const EMPTY_VENDOR_BRANDING: VendorBranding = {
  vendorName: null,
  logoUrl: null,
  headline: null,
  bodyText: null,
  successText: null,
  questionnaireSlug: null,
};

const BrandLockup: React.FC<{ branding: VendorBranding }> = ({ branding }) => {
  const [failed, setFailed] = useState(false);
  const label = branding.vendorName;

  if (branding.logoUrl && !failed) {
    return (
      <img
        className="vendor-offer-lockup"
        src={branding.logoUrl}
        alt={label ? `Heal and ${label}` : 'Heal'}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <>
      <img src={logoSmall} alt="Heal" className="vendor-offer-heal-mark" />
      {label ? <p className="vendor-offer-vendor-name">{label}</p> : null}
    </>
  );
};

export const VendorOfferShell: React.FC<{
  branding: VendorBranding;
  children: React.ReactNode;
  showBranding?: boolean;
  layout?: 'default' | 'questionnaire';
}> = ({ branding, children, showBranding = true, layout = 'default' }) => {
  const [isMobile, setIsMobile] = useState(
    () => (typeof window !== 'undefined' ? window.innerWidth <= 768 : true)
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="vendor-offer-page">
      <div
        className="vendor-offer-bg"
        style={{ backgroundImage: `url(${isMobile ? homeMobile : home})` }}
      />
      <div
        className={`vendor-offer-content${
          layout === 'questionnaire' ? ' vendor-offer-layout-questionnaire' : ''
        }`}
      >
        {showBranding ? (
          <div className="vendor-offer-brands">
            <BrandLockup branding={branding} />
          </div>
        ) : null}
        {children}
      </div>
    </div>
  );
};
